module.exports = __webpack_public_path__ + "static/img/AnxunLogo.b14ea7f4.png";